export enum Steps {
    LIST_DOWNLOAD_OPTIONS = "listDownloadOption",
    CUSTOM_LISTS = "customLists",
    COLUMN_LISTS = "columns",
    FILTERS = "filters",
}
